export const CURRENT_USER_BANK: number = 1
export const USER_BANK_LIMIT: number = 6
export const REGEX_ALPHABET_UNICODE: RegExp = /^[A-Za-z \s]*$/
export const TIME_DELAY_HIDDEN_MODAL: number = 2000
export const OTP_LIMIT: number = 6
export const OTP_EXPIRED_TIME: number = 5 * 60
export const OTP_EXPIRED_TIME_DISPLAY: string = '05:00'
export const MESSAGE_UNAUTHORIZED = 'Unauthorized'

export const API_ERROR_STATUS = {
  ERROR: {
    title: 'Thất bại',
    status: '',
    message: '',
  },
  INCORRECT_BANK_ACCOUNT_1ST: {
    title: 'Còn 2 lần thử',
    status: 'INCORRECT_BANK_ACCOUNT_1ST',
    message:
      'Tài khoản ngân hàng phải trùng với tên người dùng.\n Quý khách vui lòng thử lại.',
  },
  INCORRECT_BANK_ACCOUNT_2ND: {
    title: 'Còn 1 lần thử',
    status: 'INCORRECT_BANK_ACCOUNT_2ND',
    message:
      'Tài khoản ngân hàng phải trùng với tên người dùng.\n Quý khách vui lòng thử lại.',
  },
  INCORRECT_BANK_ACCOUNT_3RD: {
    title: 'Đã hết lượt thử',
    status: 'INCORRECT_BANK_ACCOUNT_3RD',
    message:
      'Số lần thử đã đạt mức tối đa.\n Quý khách vui lòng <span style="color: #f9fbff">Liên hệ CSKH</span> để được hỗ trợ.',
  },
  BLANK_BANK_ACCOUNT_NAME: {
    title: 'Thất bại',
    status: 'BLANK_BANK_ACCOUNT_NAME',
    message: 'Vui lòng nhập họ và tên người nhận.',
  },
}
